module.exports = __webpack_public_path__ + "static/media/acm_logo.56fc0ceb.png";